import React, { FC } from 'react';

import { useDesktop, Stack, useMediaSwitch, Typography, useMobile, Box } from 'Modules/ui3';
import { useTranslation } from 'Modules/core/i18n';
import { fileUrl } from 'Modules/ui';

import NoteImageDesktop from './assets/NoteImageDesktop.png';
import NoteImageTablet from './assets/NoteImageTablet.png';
import NoteImageMobile from './assets/NoteImageMobile.png';


interface TextBlockProps {
    isMobile: boolean;
    isDesktop: boolean;
}
const TextBlock: FC<TextBlockProps> = ({ isMobile, isDesktop }) => {
    const { t } = useTranslation('note');
    return (
        <Stack
            p={isMobile ? 4 : 8}
            spacing={isDesktop ? 12 : 8}
            bgcolor='#F4F3F2'
            borderRadius={useMediaSwitch(12, 10, 8)}
        >
            <Stack spacing={useMediaSwitch(4, 3, 2)}>
                <Typography
                    fontFamily='Hauora'
                    fontSize={useMediaSwitch('40px', '32px', '24px')}
                    fontWeight={700}
                    lineHeight={useMediaSwitch('56px', '40px', '32px')}
                    color='#242424'
                >
                    {t('title1')}
                </Typography>
                <Typography
                    fontFamily='Hauora'
                    fontSize={useMediaSwitch('18px', '16px', '14px')}
                    fontWeight={500}
                    lineHeight={isMobile ? '20px' : '24px'}
                    color='#969592'
                >
                    {t('description1')}
                </Typography>
            </Stack>
            <Stack spacing={isMobile ? 2 : 4}>
                <Typography
                    fontFamily='Hauora'
                    fontSize={isDesktop ? '32px' : '24px'}
                    fontWeight={700}
                    lineHeight={isDesktop ? '40px' : '32px'}
                    color='#242424'
                >
                    {t('title2')}
                </Typography>
                <Typography
                    fontFamily='Hauora'
                    fontSize={useMediaSwitch('18px', '16px', '14px')}
                    fontWeight={500}
                    lineHeight={isMobile ? '20px' : '24px'}
                    color='#969592'
                >
                    {t('description2')}
                </Typography>
            </Stack>
        </Stack>
    );
};

export const Note: FC = () => {
    const isDesktop = useDesktop();
    const isMobile = useMobile();
    return (
        <Stack
            pt={useMediaSwitch(22, 6, 5)}
            px={useMediaSwitch(12, 6, 2)}
            pb={useMediaSwitch(22, 6, 2)}
            mt={useMediaSwitch(0, -10, -8)}
            spacing={useMediaSwitch(16, 12, 8)}
            bgcolor='#FFF'
            alignItems='center'
            justifyContent='center'
            zIndex={2}
            {...!isDesktop && {
                sx: ({ spacing }) => ({
                    borderTopLeftRadius: spacing(isMobile ? 8 : 10),
                    borderTopRightRadius: spacing(isMobile ? 8 : 10),
                    borderBottomRightRadius: spacing(10),
                    borderBottomLeftRadius: spacing(10),
                }),
            }}
        >
            <Box
                width='100%'
                maxWidth='1200px'
                {...isMobile && {
                    px: 3,
                }}
            >
                <Typography
                    fontFamily='Hauora'
                    fontSize={useMediaSwitch('72px', '56px', '32px')}
                    fontWeight={700}
                    lineHeight={isMobile ? '1.25' : '1.3'}
                >
                    Обратите внимание
                </Typography>
            </Box>
            <Stack
                direction={isDesktop ? 'row' : 'column-reverse'}
                spacing={isDesktop ? 6 : 2}
                maxWidth='1200px'
                width='100%'
            >
                <TextBlock isMobile={isMobile} isDesktop={isDesktop} />
                <Box
                    height={isDesktop ? '680px' : '400px'}
                    width={isDesktop ? '524px' : '100%'}
                    flexShrink={0}
                    borderRadius={useMediaSwitch(12, 10, 8)}
                    sx={{
                        background: `url(${fileUrl(useMediaSwitch(
                            NoteImageDesktop,
                            NoteImageTablet,
                            NoteImageMobile,
                        ))}) center / cover no-repeat`,
                    }}
                />
            </Stack>
        </Stack>
    );
};
